import { FormattedMessage } from 'react-intl'

import { LinkButton } from 'Components/_theme/LinkButton/LinkButton'

import everphoneLogoLight from 'Assets/images/logos/everphone_logo_light.svg'

import { GLOBAL_ROUTE_PATHS } from 'Portal/src/router/Router.constants'

import { PublicRequestReturnLabelLanguageSwitcher } from './PublicRequestReturnLabelLanguageSwitcher'

export const PublicRequestReturnLabelHeader = () => (
  <header className="PublicRequestReturnLabelHeader">
    <div className="PublicRequestReturnLabelHeader-inner">
      <div className="PublicRequestReturnLabelHeader-logo">
        <img alt="Everphone Logo" src={everphoneLogoLight} />
      </div>

      <div className="PublicRequestReturnLabelHeader-actions">
        <PublicRequestReturnLabelLanguageSwitcher />

        <LinkButton to={GLOBAL_ROUTE_PATHS.public.contact} variant="light">
          <FormattedMessage id="PublicRequestReturnLabel_contactUs" />
        </LinkButton>
      </div>
    </div>
  </header>
)
